'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var commandBus = require('./command-bus.js');
var eventBus = require('./event-bus.js');
var queryBus = require('./query-bus.js');

var getGlobal = function () {
    /* istanbul ignore next */
    if (typeof self !== 'undefined') {
        return self;
    }
    /* istanbul ignore next */
    if (typeof window !== 'undefined') {
        return window;
    }
    /* istanbul ignore next */
    if (typeof global !== 'undefined') {
        return global;
    }
    /* istanbul ignore next */
    throw new Error('unable to locate global object');
};
getGlobal().eventBus = new eventBus.EventBus();
getGlobal().queryBus = new queryBus.QueryBus();
getGlobal().commandBus = new commandBus.CommandBus();

exports.getGlobal = getGlobal;
